import React, { useState, useEffect } from "react";
import TextTransition, { presets } from "react-text-transition";
import { motion } from "framer-motion";

const TEXTS = [
  "Frontend Developer.",
  "Backend Developer.",
  "FullStack Developer.",
  "Android Developer",
  "Data Science & Machine Learning",
];

const IntroPage = () => {
  const [index, setIndex] = useState(0);
  const [crazy, setCrazy] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => setIndex((prev) => prev + 1), 3000);
    return () => clearInterval(intervalId);
  }, []);

  const handleCrazyClick = () => {
    setCrazy(true);
    setTimeout(() => setCrazy(false), 1000); // Reset animation after 1s
  };

  return (
    <motion.div
      className="IntroPage"
      id="Home"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}>
      <motion.div
        className="content"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}>
        {/* Profile Image with Crazy Animation on Click */}
        <motion.div
          className="image"
          whileHover={{ scale: 1.1 }}
          animate={
            crazy
              ? {
                  rotate: [0, 10, -10, 20, -20, 0], // Crazy rotation
                  scale: [1, 1.2, 0.8, 1.1, 0.9, 1], // Bouncing effect
                  transition: { duration: 0.8, ease: "easeInOut" },
                }
              : {}
          }
          onClick={handleCrazyClick}>
          <div className="imageicon"></div>
        </motion.div>

        {/* Greeting */}
        <motion.div
          className="greet"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}>
          Hi, I'm <span className="name red">Surya</span>,
        </motion.div>

        {/* Tagline */}
        <motion.div
          className="tagline"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}>
          "Crafting the Web, Crunching the Data"
        </motion.div>

        {/* Changing Text Effect */}
        <motion.div
          className="changingtext"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}>
          <TextTransition springConfig={presets.wobbly} className="skills">
            {TEXTS[index % TEXTS.length]}
          </TextTransition>
        </motion.div>

        <br />

        {/* "Let's Connect" Button */}
        <motion.div
          className="btnxxx"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}>
          <a href="#Contact">
            <motion.span
              className="letsConntectButton"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}>
              Let's Connect
            </motion.span>
          </a>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default IntroPage;
